module.exports = __webpack_public_path__ + "static/img/partner-logo-12.ca44b527.png";